import { API_ENDPOINTS } from '../../services/apiEndpoints';
import { apiUtils } from '../../hooks/useApi';
import type {
  HotelStepsResponse,
  HotelStepsData,
  QuestionnaireResponse,
  Answer,
  SourcesResponse,
  SourcesData,
} from '../../types/api';

/**
 * Service to fetch hotel steps data
 */
export const fetchHotelStepsService = async (
  hotelId: string,
  isFasttrack?: boolean
): Promise<HotelStepsData> => {
  // console.log('🔍 Fetching hotel steps:', { hotelId });

  const response = await apiUtils.get<HotelStepsResponse>(
    API_ENDPOINTS.hotels.steps(hotelId, isFasttrack)
  );

  const result = response.data.data;
  // console.log('📡 Steps Response:', result);

  return result;
};

/**
 * Service to fetch questionnaire data and initialize answers
 */
export const fetchQuestionnaireService = async (
  hotelId: string,
  stepKey: string,
  submissionId?: string,
  isFasttrack?: boolean
): Promise<{
  questionnaireData: any;
  initialAnswers: Record<string, Answer>;
}> => {
  // console.log('🔍 Fetching questionnaire:', { hotelId, stepKey, submissionId });
  const response = await apiUtils.get<QuestionnaireResponse>(
    API_ENDPOINTS.hotels.questionnaire(hotelId, stepKey, submissionId, isFasttrack)
  );

  // console.log('📡 Questionnaire Response:', response.data);
  const data = response.data.data;
  const answers = data.answers || {};

  // Initialize answers with default values
  const initialAnswers: Record<string, Answer> = { ...answers };

  return {
    questionnaireData: data,
    initialAnswers,
  };
};

/**
 * Service to fetch sources data
 */
export const fetchSourcesService = async (
  hotelId: string,
  submissionId?: string,
  isFasttrack?: boolean
): Promise<SourcesData> => {
  // console.log('🔍 Fetching sources:', { hotelId, submissionId });

  const response = await apiUtils.get<SourcesResponse>(
    API_ENDPOINTS.hotels.questionnaire(hotelId, 'sources', submissionId, isFasttrack)
  );

  const result = response.data;
  // console.log('📡 Sources Response:', result);

  return result.data;
};
